// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zTq6","colMin":"styles_colMin__3gYcm"};